import React, { FC, ReactElement } from 'react';
import { MaintenanceScreen } from '@minecraft.splash-screens';
import { useFeatureExperiment, FEATURE_FLAGS, canSkipMaintenanceGuard } from '@blocs.features-experiments';
import { useRouter } from '@blocs.router';

interface Props {
  routes: () => ReactElement;
}
const MaintenanceGuard: FC<Props> = ({ routes: Routes }) => {
  const isUnscheduledMaintenance: boolean = useFeatureExperiment(FEATURE_FLAGS.UNSCHEDULED_MAINTENANCE);
  const isScheduledMaintenance: boolean = useFeatureExperiment(FEATURE_FLAGS.SCHEDULED_MAINTENANCE);
  const isQaViewMaintenance: boolean = useFeatureExperiment(FEATURE_FLAGS.QA_VIEW_MAINTENANCE);
  const hasQaOverride = canSkipMaintenanceGuard();
  const { search } = useRouter();
  const maintenanceMode = new URLSearchParams(search).get('mode') ?? undefined;

  if (isQaViewMaintenance || (isScheduledMaintenance && !hasQaOverride)) {
    return <MaintenanceScreen scheduled mode={maintenanceMode} />;
  }

  if (isUnscheduledMaintenance && !hasQaOverride) {
    return <MaintenanceScreen mode={maintenanceMode} />;
  }

  return <Routes />;
};

export default MaintenanceGuard;
